import { BagDelegate, type ToolPartProps } from './_base'
import { RunbookExecutionToolMessage } from '../ScreenataChatToolMessages'

// All five actions render rich UI in the bag:
//   execute / resume / approve / reject  → embedded RunbookRunContent
//   status                                → step-count detail
// Each tool gets its own component so callers can find/customize per action.

export function RunbookExecutionExecuteToolMessage(props: ToolPartProps) {
  return (
    <BagDelegate
      Component={RunbookExecutionToolMessage}
      action='execute'
      {...props}
    />
  )
}

export function RunbookExecutionStatusToolMessage(props: ToolPartProps) {
  return (
    <BagDelegate
      Component={RunbookExecutionToolMessage}
      action='status'
      {...props}
    />
  )
}

export function RunbookExecutionResumeToolMessage(props: ToolPartProps) {
  return (
    <BagDelegate
      Component={RunbookExecutionToolMessage}
      action='resume'
      {...props}
    />
  )
}

export function RunbookExecutionApproveToolMessage(props: ToolPartProps) {
  return (
    <BagDelegate
      Component={RunbookExecutionToolMessage}
      action='approve'
      {...props}
    />
  )
}

export function RunbookExecutionRejectToolMessage(props: ToolPartProps) {
  return (
    <BagDelegate
      Component={RunbookExecutionToolMessage}
      action='reject'
      {...props}
    />
  )
}
